<ngx-spinner bdColor="rgba(0, 0, 0, 0.4)" size="medium" color="#fff" type="square-jelly-box" [fullScreen]="true">
  <p style="color: white"> Loading... </p>
</ngx-spinner>

<div class="modal-container background-color">
  <div class="modal-header">
    <h3 class="modal-title">Pending Approval</h3>

    <button mat-icon-button (click)="cancel()" class="close-btn">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="horizontal-sections">

    <div class="section" [formGroup]="secondSectionForm" *ngIf="this.data?.current">
      <h5>Current</h5>
      <!-- Header Controls -->
      <div class="form-header">
        <mat-form-field appearance="outline" class="header-field">
          <mat-label>Name</mat-label>
          <input matInput formControlName="templateName" placeholder="Template Name" readonly>
        </mat-form-field>

        <mat-form-field appearance="outline" class="header-field">
          <mat-label>Contribution Period</mat-label>
          <input matInput formControlName="contributionPeriodName" readonly>
        </mat-form-field>

        <mat-form-field appearance="outline" class="header-field">
          <mat-label>Effective Date</mat-label>
          <input matInput [matDatepicker]="picker2" formControlName="effectiveDate" readonly>
          <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
          <mat-datepicker #picker2></mat-datepicker>
        </mat-form-field>
      </div>

      <!-- Threshold Table -->
      <div class="threshold-table" formArrayName="thresholds">
        <div class="table-row table-header">
          <div>Threshold Start</div>
          <div>Threshold End</div>
          <div>Contract Rate %</div>
          <div>Perm Rate %</div>
        </div>

        <ng-container *ngFor="let group of secondThresholdFormArray.controls; let i = index">
          <div class="table-row" [formGroupName]="i">
            <mat-form-field appearance="outline">
              <mat-label>Start</mat-label>
              <span matPrefix>$&nbsp;</span>
              <input matInput formControlName="min" placeholder="Start" />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>End</mat-label>
              <span matPrefix>$&nbsp;</span>
              <input matInput formControlName="max" placeholder="End" />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Contract Rate %</mat-label>
              <span matSuffix>%</span>
              <input matInput formControlName="contractRate" placeholder="Contract Rate %" />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Perm Rate %</mat-label>
              <span matSuffix>%</span>
              <input matInput formControlName="permRate" placeholder="Perm Rate %" />
            </mat-form-field>
          </div>
        </ng-container>
      </div>
    </div>
    <!-- SECTION 1 -->

    <div class="section" [formGroup]="firstSectionForm">
      <h5>To Be Approved</h5>
      <!-- Header Controls -->
      <div class="form-header">
        <div class="form-group">
          <mat-form-field appearance="fill">
            <mat-label>Name</mat-label>
            <input matInput formControlName="templateName" placeholder="Template Name" readonly>
          </mat-form-field>
        </div>

        <div class="form-group">
          <mat-form-field appearance="fill">
            <mat-label>Contribution Period</mat-label>
            <input matInput formControlName="contributionPeriodName" readonly>
          </mat-form-field>
        </div>

        <div class="form-group">
          <mat-form-field appearance="fill">
            <mat-label>Effective Date</mat-label>
            <input matInput [matDatepicker]="picker1" formControlName="effectiveDate">
            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
          </mat-form-field>
        </div>
      </div>

      <!-- Threshold Table -->
      <div class="threshold-table" formArrayName="thresholds">
        <div class="table-row table-header">
          <div>Threshold Start</div>
          <div>Threshold End</div>
          <div>Contract Rate %</div>
          <div>Perm Rate %</div>
        </div>

        <ng-container *ngFor="let group of firstThresholdFormArray.controls; let i = index">
          <div class="table-row" [formGroupName]="i">
            <mat-form-field appearance="outline" [ngClass]="{ 'strikeout': isStrikedOut }">
              <mat-label>Start</mat-label>
              <span matPrefix>$&nbsp;</span>
              <input matInput formControlName="min" placeholder="Start" />
            </mat-form-field>

            <mat-form-field appearance="outline" [ngClass]="{ 'strikeout': isStrikedOut }">
              <mat-label>End</mat-label>
              <span matPrefix>$&nbsp;</span>
              <input matInput formControlName="max" placeholder="End" />
            </mat-form-field>

            <mat-form-field appearance="outline" [ngClass]="{ 'strikeout': isStrikedOut }">
              <mat-label>Contract Rate %</mat-label>
              <span matSuffix>%</span>
              <input matInput formControlName="contractRate" placeholder="Contract Rate %" />
            </mat-form-field>

            <mat-form-field appearance="outline" [ngClass]="{ 'strikeout': isStrikedOut }">
              <mat-label>Perm Rate %</mat-label>
              <span matSuffix>%</span>
              <input matInput formControlName="permRate" placeholder="Perm Rate %" />
            </mat-form-field>
          </div>
        </ng-container>
      </div>
    </div>

  </div>


  <!-- Footer -->
   <div class="mt-2 d-flex justify-content-between">
    <button mat-flat-button class="btn-cancel" (click)="cancel()">Cancel</button>
    <button mat-flat-button class="btn-reset" (click)="reject()">Reject</button>
    <button mat-flat-button class="btn-action" (click)="approve()">Approve</button>
  </div>
</div>
